module.exports = __webpack_public_path__ + "assets/icon-variation-down.378f4667.svg";